var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"title":"alter auth"},on:{"click":_vm.alterAuth}}),_c('b-button',{attrs:{"title":"load shops"},on:{"click":_vm.loadShops}},[_vm._v(" Load Shops ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }